require('./bootstrap');
require('./config/web-sockets');
require('./config/alerts');
require('./config/vue');
require('./config/axios');
